/**
 * Created by zad on 17/10/26.
 */
export const CONTENT_NOT_FOUND = Symbol('content_not_found');
export const NOTES_NOT_FOUND = Symbol('notes_not_found');
export const NOTE_HISTORY_NOT_FOUND = Symbol('notes_not_found');

export const MAX_VIDEO_COUNT = 10;
export const PN_ITEM_MASK_CLASSNAME = 'pn-item-mask';

export const JIANSHU_EDITOR = Symbol('jianshu_editor');

export const REG_IS_QINIU = /^(http(s?):)?\/\/(upload-images\.jianshu\.io\/upload_images\/|jianshu-(dev\.u|staging)\.qiniudn\.com\/|upload\.jianshu\.io\/users\/upload_avatars\/)/i;



// WEBPACK FOOTER //
// ./src/constants/variables.js